import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import type { Role } from '@larice/contracts'
import { useAuth } from './AuthProvider'
import { LoadingState } from '../components/common/AsyncState'

export function ProtectedRoute({ children, role = 'viewer' }: { children: ReactNode; role?: Role }) {
  const auth = useAuth()
  const location = useLocation()
  if (auth.loading)
    return (
      <div className="full-page-state">
        <LoadingState label="Checking FreeIPA session…" />
      </div>
    )
  if (!auth.user) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (!auth.hasRole(role)) return <Navigate to="/console" replace />
  return children
}
